module.exports = __webpack_public_path__ + "components/flag/static/square/gq-de617bd6939517e39b947af4497f801d.svg";